export { default } from './ThankYouStep';
